import { mount } from "@vue/test-utils";
import LargeCircleIcon from "@/components/core/LargeCircleIcon";

describe("LargeCircleIcon test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(LargeCircleIcon);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component LargeCircleIcon", () => {
    expect(wrapper).toBeDefined();
  });
});
